const DATASTORE_TEMPLATE = {
    appVersion: "0.0.1",
    exportDataVersion: 1,
    titles: [],
    items: [],
};
export default DATASTORE_TEMPLATE;
